<template>
    <div style="position: relative">
        <title-and-edit currentViewTitle="Favorittbehandlinger" @toggleEdit="toggleEdit" :edit="edit" :hideEditButton="!filteredTreatments.length" :layout="layout"/>
        <div class="profile__container--content__treatment primary-font pt-5">
            <div v-if="filteredTreatments.length">
                <profile-dropdown v-if="layout == 'portal'" :items="salons" @select-item="updateTreatmentList" :layout="layout"></profile-dropdown>
                <div v-for="treatment in visiblePages" :key="treatment.title">
                    <treatment :treatment="treatment" :edit="edit" @delete-treatment="updateTreatments" :layout="layout" @close-profile="$emit('close-profile')"></treatment>
                </div>
                <v-pagination
                    v-if="filteredTreatments.length > 10"
                    class="profile__container--content__mysalons--pagination my-5"
                    circle
                    v-model="page"
                    :length="pages"
                    :total-visible="10"
                    prev-icon="fxt-chevron-left"
                    next-icon="fxt-chevron-right">
                </v-pagination>
                <div v-if="selectedSalon !== '' && false" class="d-flex justify-start">
                    <v-btn
                        class="font-weight-bold secondary-font text-none my-6"
                        color="primary"
                        rounded
                        outlined
                        elevation="0"
                        @click="treatmentsRedirect()"
                    >
                        <div>Finn flere i behandlinger</div>
                    </v-btn>
                </div>
            </div>
            <div v-else>
                <v-overlay :value="loading" color="white" absolute style="height: 600px">
                    <v-progress-circular
                        color="var(--v-primary-base)"
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
                <no-content v-if="!loading && !filteredTreatments.length" title="Du har ingen favorittbehandlinger ennå." icon="fxt-treatment" buttonText="Finn behandling" hideButton :layout="layout"/>
            </div>
        </div>
    </div>
</template>

<script>
import Treatment from './components/Treatment.vue'
import { ProfileDropdown, NoContent, TitleAndEdit } from '../../../Common/CommonComponents'
import ProfileSvc from '../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { Treatment, ProfileDropdown, NoContent, TitleAndEdit },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
    },
    data: () => ({
        edit: false,
        loading: false,
        treatments: [],
        filteredTreatments: [],
        salons: [],
        selectedSalon: '',
        page: 1,
        perPage: 10,
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        pages() {
            return this.filteredTreatments.length > 10
                ? Math.ceil(this.filteredTreatments.length / 10)
                : 1;
        },
        visiblePages () {
            return this.filteredTreatments.slice((this.page - 1)* this.perPage, this.page* this.perPage)
        }
    },
    methods: {
        async updateTreatments(treatment) {
            var result = await profileSvc.UpdateFavoriteTreatments(this.bookingApi, treatment.treatmentId, treatment.siteId)
            if (result) {
                this.page = 1
                this.$emit('update-treatments')
                this.treatments = this.sortTreatments(await profileSvc.GetFavoriteTreatments(this.bookingApi, this.layout == 'chain' ? (this.$store.getters['salon/getSiteIds'] ? this.$store.getters['salon/getSiteIds'] : this.$store.getters['site/getChainSiteIds']) : [101]))
                this.filteredTreatments = this.treatments
            }
        },
        portalUrl() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL : this.$config.PORTAL_URL
        },
        /**
         * Update treatments displayed based on which salon is selected in the dropdown
         */
        updateTreatmentList(salon) {
            this.filteredTreatments = salon == 'Alle' ? this.treatments : this.treatments.filter(x => x.siteName == salon)
            this.selectedSalon = salon;
        },
        sortTreatments(treatments) {
            return treatments.sort(function(a, b) {
                return (a.treatmentName < b.treatmentName) ? -1 : (a.treatmentName > b.treatmentName) ? 1 : 0;
            });
        },
        toggleEdit() {
            this.edit = !this.edit
        }
    },
    async created() {
        profileSvc = await ProfileSvc(this.$axios);
        this.loading = true
        this.treatments = this.sortTreatments(await profileSvc.GetFavoriteTreatments(this.bookingApi, this.layout == 'chain' ? (this.$store.getters['salon/getSiteIds'] ? this.$store.getters['salon/getSiteIds'] : this.$store.getters['site/getChainSiteIds']) : []))
        this.filteredTreatments = this.treatments
        this.salons = this.treatments.length ? this.treatments.map(x => x.siteName) : []
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>